import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import requestGetApprovalRequestsAll from 'businessTraveller/api/requestGetApprovalRequestsAll'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import { getChannelMarkup } from 'selectors/channelMarkupSelector'

function fetchBusinessApprovalRequests(
  businessId: string,
  employeeId: string,
  currentRegionCode: string,
  employees: Array<App.BusinessTraveller.EmployeeFromMeEndpoint>,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const channelMarkup = getChannelMarkup(state)

    dispatch({
      type: API_CALL,
      api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_APPROVAL_REQUEST,
      request: () => requestGetApprovalRequestsAll({
        businessId,
        channelMarkup,
        currentRegionCode,
        employeeId,
        employees,
      }),
    })
  }
}

export default fetchBusinessApprovalRequests
